import { useDispatch, useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { ButtonGroup, Form, Button, Row, Col } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import {
  addProjectAssetTaskReview,
  getAllProjectReviews,
  getProjectAssetTasks,
} from "../../helpers/axios/projectsAxios";
import Spinner from "react-bootstrap/Spinner";
import {
  SELECTED_DRAWING_SET,
  SELECTED_MODELS,
  updateModelState,
} from "../../helpers/reducers/ModelReducer";
import VisibleOrNotRenderer from "../ag-grid/VisibleOrNotRenderer";
import {
  agGridOptionsSingle,
  agGridTheme,
  civilRoles,
  customStyles,
  elecRoles,
  generalRoles,
  MandatoryExplanation,
  MandatoryFieldIndicator,
  mechRoles,
  processRoles,
  structuralRoles,
} from "../../helpers/constants/Constants";
import DrawingSetModal from "../drawingSets/DrawingSetModal";
import {
  ALL_PROJECT_REVIEWS,
  updateGlobalState,
} from "../../helpers/reducers/GlobalReducer";

const InformationManagement = ({ viewerState, modelNodes }) => {
  const {
    userDetails,
    allProjectUsers,
    selectedProject,
    regionalStatuses,
    accDrawingSets,
    cloudFiles,
  } = useSelector((state) => state.globalReducer);
  const {
    selectedModels,
    modelLoaded,
    selectedDrawingSet,
    selectedObjectData,
  } = useSelector((state) => state.modelReducer);

  const [checkerRoles, setCheckerRoles] = useState([]);
  // const [statuses, setStatuses] = useState();
  // const [primaryDisciplineCheck, setPrimaryDisciplineCheck] = useState([]);
  const [submissionData, setSubmissionData] = useState();
  // const [isSaving, setIsSaving] = useState(false);
  // const [submitModalOpen, setSubmitModalOpen] = useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [drawingSetModal, setDrawingSetModal] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [infoLoading, setInfoLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [viewGridPageSizeMode, setViewGridPageSizeMode] = useState("auto");
  const dispatch = useDispatch();

  // useEffect(() => {
  //   if (selectedProject) {
  //     fetchStatuses(selectedProject[0].mviewProjectInfo.regionCode);
  //   }
  // }, [selectedProject]);

  // useEffect(() => {
  //   validateReviewButton();
  // }, [modelFilterState]);

  const validateReviewButton = (discipline) => {
    //lots of validation checks validateReviewButton(tempSelectedFiles[0]?.discipline)

    switch (discipline) {
      case "Civil":
      case "Civil Engineer":
        if (civilRoles.includes(userDetails?.role)) {
          setCheckerRoles([
            "Civil Checker",
            "Civil Reviewer",
            "Civil Approver",
            "Design Manager",
            "Admin",
          ]);
          // setIsDrawingSetValid(drawingSetValidation("Civil"));
        } else {
          setCheckerRoles([]);
          // setIsValid(false);
          // setIsDrawingSetValid(false);
        }
        break;
      case "Mechanical":
        if (mechRoles.includes(userDetails?.role)) {
          setCheckerRoles([
            "Mechanical Checker",
            "Mechanical Reviewer",
            "Mechanical Approver",
            "Design Manager",
            "Admin",
          ]);
          // setIsDrawingSetValid(drawingSetValidation("Mechanical"));
        } else {
          setCheckerRoles([]);
          // setIsValid(false);
          // setIsDrawingSetValid(false);
        }
        break;
      case "Electrical":
      case "EICA":
        if (elecRoles.includes(userDetails?.role)) {
          setCheckerRoles([
            "Electrical Checker",
            "Electrical Reviewer",
            "Electrical Approver",
            "Design Manager",
            "Admin",
          ]);
          // setIsDrawingSetValid(drawingSetValidation("Electrical"));
        } else {
          setCheckerRoles([]);
          // setIsValid(false);
          // setIsDrawingSetValid(false);
        }
        break;
      case "Process":
      case "Process Engineering":
        if (processRoles.includes(userDetails?.role)) {
          setCheckerRoles([
            "Process Checker",
            "Process Reviewer",
            "Process Approver",
            "Design Manager",
            "Admin",
          ]);
          // setIsDrawingSetValid(drawingSetValidation("Process"));
        } else {
          setCheckerRoles([]);
          // setIsValid(false);
          // setIsDrawingSetValid(false);
        }
        break;
      case "Structural":
        if (structuralRoles.includes(userDetails?.role)) {
          setCheckerRoles([
            "Structural Checker",
            "Structural Reviewer",
            "Structural Approver",
            "Design Manager",
            "Admin",
          ]);
          // setIsDrawingSetValid(drawingSetValidation("Structural"));
        } else {
          setCheckerRoles([]);
          // setIsValid(false);
          // setIsDrawingSetValid(false);
        }
        break;
      case "General":
      case "Multi-disciplinary":
        if (generalRoles.includes(userDetails?.role)) {
          setCheckerRoles([
            "Civil Checker",
            "Civil Reviewer",
            "Civil Approver",
            "Mechanical Checker",
            "Mechanical Reviewer",
            "Mechanical Approver",
            "Electrical Checker",
            "Electrical Reviewer",
            "Electrical Approver",
            "Structural Checker",
            "Structural Reviewer",
            "Structural Approver",
            "Process Checker",
            "Process Reviewer",
            "Process Approver",
            "Design Manager",
            "Admin",
          ]);
          // setIsDrawingSetValid(drawingSetValidation("General"));
        } else {
          setCheckerRoles([]);
          // setIsValid(false);
          // setIsDrawingSetValid(false);
        }
        break;

      default:
        setCheckerRoles([]);
        // setIsValid(false);
        // setIsDrawingSetValid(false);
        break;
    }
  };

  const isAuthorised = () => {
    let authorized = false;
    switch (selectedFiles[0]?.discipline) {
      case "Civil":
      case "Civil Engineer":
        if (civilRoles.includes(userDetails?.role)) {
          authorized = true;
        }
        break;
      case "Mechanical":
        if (mechRoles.includes(userDetails?.role)) {
          authorized = true;
        }
        break;
      case "Electrical":
      case "EICA":
        if (elecRoles.includes(userDetails?.role)) {
          authorized = true;
        }
        break;
      case "Process":
      case "Process Engineering":
        if (processRoles.includes(userDetails?.role)) {
          authorized = true;
        }
        break;
      case "Structural":
        if (structuralRoles.includes(userDetails?.role)) {
          authorized = true;
        }
        break;
      case "General":
      case "Multi-disciplinary":
        if (generalRoles.includes(userDetails?.role)) {
          authorized = true;
        }
        break;
      default:
        authorized = false;
        break;
    }

    return authorized;
  };

  // const drawingSetValidation = (discipline) => {
  //   let primaryDisciplineCheck = [];
  //   regionalStatuses?.forEach((status) => {
  //     if (status.primary) {
  //       primaryDisciplineCheck.push(status.code);
  //     }
  //   });

  //   let disciplineModels = [];
  //   let otherModels = [];
  //   allDocs
  //     .filter((o) => o.processArea === modelFilterState?.process?.processArea)
  //     .forEach((doc) => {
  //       if (doc.discipline === discipline) {
  //         disciplineModels.push(doc);
  //       } else {
  //         otherModels.push(doc);
  //       }
  //     });
  //   const disciplineValid = disciplineModels.every((model) =>
  //     primaryDisciplineCheck.includes(model.status)
  //   );
  //   const otherValid = otherModels.every((model) => model.status !== "S0");
  //   if (
  //     disciplineValid &&
  //     otherValid &&
  //     userDetails?.role === "Design Manager"
  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };

  /////////// AG-GRID STARTING //////////
  const [gridApi, setGridApi] = useState();
  const [smallGridApi, setSmallGridApi] = useState();
  const gridRef = useRef(null);

  const smallGridReady = (params) => {
    setSmallGridApi(params.api);
    requestAnimationFrame(() => {
      params.api.autoSizeAllColumns();
    });
  };
  const gridReady = (params) => {
    setGridApi(params.api);
    requestAnimationFrame(() => {
      fitViewGridColumns(params.api);
      applyViewGridPageSizeMode(params.api);
    });
  };

  const fitViewGridColumns = useCallback(
    (apiInput) => {
      const api = apiInput || gridApi;
      if (!api) return;

      api.sizeColumnsToFit();
    },
    [gridApi],
  );

  const applyViewGridPageSizeMode = useCallback(
    (apiInput) => {
      const api = apiInput || gridApi;
      if (!api) return;

      const allRowCount = Math.max(selectedModels?.length || 0, 1);

      if (viewGridPageSizeMode === "all") {
        api.setGridOption("paginationAutoPageSize", false);
        api.setGridOption("paginationPageSize", allRowCount);
      } else if (viewGridPageSizeMode === "auto") {
        api.setGridOption("paginationAutoPageSize", true);
      } else {
        const pageSize = Number(viewGridPageSizeMode) || 25;
        api.setGridOption("paginationAutoPageSize", false);
        api.setGridOption("paginationPageSize", pageSize);
      }

      api.paginationGoToFirstPage();
    },
    [gridApi, selectedModels, viewGridPageSizeMode],
  );

  const columnDefs = useMemo(
    () => [
      {
        field: "visible",
        headerName: "",
        width: 0,
        filter: false,
        sortable: false,
        resizable: false,
        cellRenderer: VisibleOrNotRenderer,
        cellStyle: { paddingLeft: 5, paddingRight: 0 },
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        suppressHeaderContextMenu: true,
        headerClass: "info-ag-eye-class",
      },
      { field: "id", hide: true },
      {
        field: "task",
        headerName: "Title",
        filter: false,
        sortable: false,
        resizable: false,
        headerClass: "info-ag-class",
        cellStyle: { fontSize: "10px", paddingRight: 0 },
      },
      {
        field: "discipline",
        headerName: "Discipline",
        filter: false,
        sortable: false,
        resizable: false,
        headerClass: "info-ag-class",
        cellStyle: { fontSize: "10px", paddingRight: 0 },
      },
         {
        field: "asset",
           headerName: "Regional Designation",
          filter: false,
        sortable: false,
        resizable: false,
        headerClass: "info-ag-class",
        cellStyle: { fontSize: "10px", paddingRight: 0 },
      },
      {
        field: "mwhAssetName", headerName: "MWH Asset",
          filter: false,
        sortable: false,
        resizable: false,
        headerClass: "info-ag-class",
        cellStyle: { fontSize: "10px", paddingRight: 0 },
       },
      {
        field: "documentName",
        headerName: "Document Number",
          filter: false,
        sortable: false,
        resizable: false,
        headerClass: "info-ag-class",
        cellStyle: { fontSize: "10px", paddingRight: 0 },
      },
      {
        field: "status",
          filter: false,
        sortable: false,
        resizable: false,
        headerClass: "info-ag-class",
        cellStyle: { fontSize: "10px", paddingRight: 0 },
      },
      {
        headerName: "Revision",
        valueGetter: (p) => {
          const currentStatus = regionalStatuses.find(
            (s) => s.code === p.data.status,
          );
          if (currentStatus?.published) {
            return p.data.publishedRevision;
          }

          return p.data.sharedRevision;
        },
          filter: false,
        sortable: false,
        resizable: false,
        headerClass: "info-ag-class",
        cellStyle: { fontSize: "10px", paddingRight: 0 },
      },      
      {
        headerName: "Last Updated",
        field: "lastUpdated",
        filter: false,
        sortable: false,
        resizable: false,
        headerClass: "info-ag-class",
        cellStyle: { fontSize: "10px", paddingRight: 0 }, },
    ],
    [],
  );

  const viewColumnDefs = useMemo(
    () => [
      { field: "id", hide: true },
      { field: "publishedRevision", hide: true },
      { field: "sharedRevision", hide: true },
      { field: "versions", hide: true },
      {
        field: "asset",
        headerName: "Regional Designation",
      },
      { field: "mwhAssetName", headerName: "MWH Asset" },
      {
        field: "task",
        headerName: "Title",
      },
      {
        field: "documentName",
        headerName: "Document Number",
      },
      {
        field: "discipline",
      },
      {
        field: "status",
      },
      {
        headerName: "Revision",
        valueGetter: (p) => {
          const currentStatus = regionalStatuses.find(
            (s) => s.code === p.data.status,
          );
          if (currentStatus?.published) {
            return p.data.publishedRevision;
          }

          return p.data.sharedRevision;
        },
      },
      {headerName: "Last Updated", field: "lastUpdated" },
    ],
    [regionalStatuses],
  );

  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(
    () => ({
      sortable: true,

      filter: "agSetColumnFilter",
    }),
    [],
  );

  const smallGridOptions = useMemo(
    () => ({
      ...agGridOptionsSingle,
      autoSizeStrategy: {
        type: "fitCellContents",
        skipHeader: false,
      },
      rowSelection: {
        ...agGridOptionsSingle.rowSelection,
        checkboxes: false,
      },
      pagination: false,
    }),
    [],
  );

  useEffect(() => {
    if (!smallGridApi) {
      return;
    }

    smallGridApi.autoSizeAllColumns();
  }, [smallGridApi, selectedModels]);

  useEffect(() => {
    if (!smallGridApi) {
      return;
    }

    const selectedModelUrn = selectedObjectData?.urn;

    if (!selectedModelUrn) {
      smallGridApi.deselectAll();
      return;
    }

    const selectedNode = smallGridApi.getRowNode(selectedModelUrn);

    if (!selectedNode) {
      smallGridApi.deselectAll();
      return;
    }

    smallGridApi.deselectAll();
    selectedNode.setSelected(true);
    smallGridApi.ensureNodeVisible(selectedNode, "middle");
  }, [smallGridApi, selectedObjectData]);

  useEffect(() => {
    applyViewGridPageSizeMode();
    fitViewGridColumns();
  }, [applyViewGridPageSizeMode, fitViewGridColumns]);

  const selectionChanged = () => {
    const tempSelectedFiles = gridApi.getSelectedRows();
    setSelectedFiles(tempSelectedFiles);
    validateReviewButton(tempSelectedFiles[0]?.discipline);
    // assignCheckerRoles(tempSelectedFiles[0]?.discipline); //THIS CREATING AN ETERNAL LOOP NEED TO LOOK AT IT.
  };

  // const onCloseModal = () => {
  //   setSubmitModalOpen(false);
  //   setSubmissionData();
  // };

  const requestAssetReview = async () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    const formattedToday = dd + "/" + mm + "/" + yyyy;

    const tempCloudFile = cloudFiles.find((o) =>
      o?.attributes?.displayName?.includes(selectedFiles[0]?.documentName),
    );
    const tempSelectedModel = {
      id: tempCloudFile?.relationships?.derivatives?.data?.id,
      documentName: tempCloudFile?.attributes.name,
      storageLocation: null, //tempCloudFile?.relationships?.storage?.meta?.link?.href,
      task: selectedFiles[0]?.task,
      status: selectedFiles[0]?.status,
      sharedRevision: selectedFiles[0]?.sharedRevision,
      publishedRevision: selectedFiles[0]?.publishedRevision,
      projectAssetTaskId: selectedFiles[0]?.projectAssetTaskId,
      selectedVersion: selectedFiles[0]?.versions.find(
        (v) => v.current === true,
      )?.id,
      asset: selectedFiles[0]?.asset,
      versions: selectedFiles[0]?.versions,
      visible: true,
      discipline: selectedFiles[0]?.discipline,
    };

    const reviewData = {
      ...submissionData,
      proposedStatus: submissionData.proposedStatus.data.code,
      submittedBy: userDetails?.email,
      submittedDate: formattedToday,
      projectAssetTaskId: selectedFiles[0]?.projectAssetTaskId,
      discipline: selectedFiles[0]?.discipline,
      selectedModels: [tempSelectedModel],
      storageLocation: null,
    };
    const newReview = await addProjectAssetTaskReview(reviewData);
    fetchAllProjectReviews(selectedProject[0].id);
    setSubmissionData();

    window.alert(newReview.data.message);
    hideStatusModal();
  };

  const fetchAllProjectReviews = async (projectId) => {
    const data = await getAllProjectReviews(projectId);
    dispatch(
      updateGlobalState({
        value: data,
        stateName: ALL_PROJECT_REVIEWS,
      }),
    );
  };

  // const createDrawingSet = async () => {
  //   setIsSaving(true);
  //   //take filter asset and discipline and send to back end
  //   const addSet = await addDrawingSet(
  //     selectedProject[0].id,
  //     modelFilterState.process.processArea,
  //     modelFilterState.discipline
  //   );
  //   setIsSaving(false);
  //   alert(addSet.data.message);
  // };

  const closeViewModal = () => {
    setViewModalOpen(false);
  };
  const closeDrawingSetModal = () => {
    setDrawingSetModal(false);
  };

  const hideStatusModal = () => {
    setStatusModal(false);
    setSubmissionData();
  };

  const modalSelectStyles = {
    ...customStyles,
    control: (provided, state) => ({
      ...provided,
      fontSize: "12px",
      background:
        "linear-gradient(120deg, rgba(58,58,58,0.34) 0%, rgba(0,93,133,0.42) 100%)",
      borderColor: state.isFocused
        ? "rgba(147,213,0,0.72)"
        : "rgba(242,242,242,0.34)",
      minHeight: "34px",
      height: "34px",
      borderRadius: "999px",
      boxShadow: state.isFocused
        ? "0 0 0 2px rgba(147,213,0,0.24), 0 8px 18px rgba(58,58,58,0.22)"
        : "0 8px 18px rgba(58,58,58,0.2)",
      "&:hover": {
        borderColor: "rgba(147,213,0,0.72)",
        boxShadow:
          "0 0 0 2px rgba(147,213,0,0.24), 0 8px 18px rgba(58,58,58,0.22)",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "rgba(242,242,242,0.96)",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "rgba(242,242,242,0.7)",
    }),
    input: (provided) => ({
      ...provided,
      color: "rgba(242,242,242,0.96)",
    }),
    option: (provided, state) => ({
      ...provided,
      color: "rgba(242,242,242,0.95)",
      background: state.isSelected
        ? "linear-gradient(120deg, rgba(147,213,0,0.42), rgba(156,197,202,0.28))"
        : state.isFocused
          ? "linear-gradient(120deg, rgba(147,213,0,0.26), rgba(156,197,202,0.2))"
          : "rgba(0,0,0,0)",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "12px",
      border: "1px solid rgba(242,242,242,0.24)",
      background:
        "linear-gradient(165deg, rgba(58,58,58,0.96) 0%, rgba(0,93,133,0.92) 100%)",
      boxShadow: "0 14px 28px rgba(58,58,58,0.28)",
      overflow: "hidden",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "rgba(156,197,202,0.95)",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  const modelClicked = () => {
    if (modelLoaded) {
      const clickedModel = smallGridApi.getSelectedRows();
      if (clickedModel.length === 0) return;
      let changedModel;
      const updatedModels = selectedModels?.map((model) => {
        if (model.id === clickedModel[0].id) {
          changedModel = { ...model, visible: !model.visible };
          return { ...model, visible: !model.visible };
        } else {
          return model;
        }
      });
      dispatch(
        updateModelState({
          value: updatedModels,
          stateName: SELECTED_MODELS,
        }),
      );

      const node = modelNodes.filter((node) => node.urn === changedModel.id);

      //if viewer is open continue
      if (node.length > 0) {
        if (changedModel.visible) {
          viewerState.show(node[0].bubble);
        } else {
          viewerState.hide(node[0].bubble);
        }
      }
    }
  };

  const drawingSetSelectHandler = (e) => {
    const selectedSet = e.data;

    dispatch(
      updateModelState({
        value: selectedSet,
        stateName: SELECTED_DRAWING_SET,
      }),
    );
  };

  const openMoreInfo = async () => {
    const mviewDocs = await getProjectAssetTasks(selectedProject[0].id);
    //check selectedModels to new ones and update where required

    let tempSelectedModels = [...selectedModels];
    const updatedSelectedmodels = tempSelectedModels.map((model) => {
      const selectedDoc = mviewDocs.find(
        (o) => o.docNumber === model.documentName.split(".")[0],
      );
      if (selectedDoc) {
        return {
          ...model,
          publishedRevision: selectedDoc.publishedRevision,
          selectedVersion: selectedDoc.versions.find((v) => v.current === true)
            ?.id,
          sharedRevision: selectedDoc.sharedRevision,
          status: selectedDoc.status,
          versions: [...selectedDoc.versions],
        };
      } else {
        return model;
      }
    });

    //set SelectedModels to new models
    dispatch(
      updateModelState({
        value: updatedSelectedmodels,
        stateName: SELECTED_MODELS,
      }),
    );
    //open modal to view latest info
    setInfoLoading(false);
    setViewModalOpen(true);
  };

  return (
    <>
      <div
        className="infomanagement"
        // style={{ textAlign: "center", paddingTop: "2px" }}
      >
        <h5>Information Management</h5>
        <h6>Model Information</h6>
        <div className="row">
          <div
            className="col"
            style={{ textAlign: "center", margin: "5px" }}
            data-bs-toggle="tooltip"
          >
            <button
              type="button"
              className="btn mwh-btn-primary btn-sm"
              onClick={(e) => {
                // setViewModalOpen(true);
                setInfoLoading(true);
                openMoreInfo();
              }}
              style={{ marginRight: "4px", fontSize: "12px" }}
            >
              {infoLoading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <span>More Information</span>
              )}
            </button>
          </div>
        </div>
        <div
          style={{
            marginTop: "5px",
            height: "50%",
            paddingRight: "15px",
            paddingLeft: "10px",
          }}
        >
          <AgGridReact
            theme={agGridTheme}
            ref={gridRef}
            rowData={selectedModels}
            getRowId={(params) => params.data.id}
            suppressScrollOnNewData={true}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            onGridReady={smallGridReady}
            // onSelectionChanged={modelClicked}
            onRowClicked={modelClicked}
            gridOptions={smallGridOptions}
          />
        </div>
        <h6>Drawing Set Information</h6>
        <div className="row">
          <div
            className="col acc-project-select-wrap"
            style={{ textAlign: "center", margin: "5px" }}
            data-bs-toggle="tooltip"
          >
            <Select
              className="acc-project-select"
              classNamePrefix="acc-project-select"
              placeholder="Please select a drawing set"
              menuPortalTarget={document.body}
              options={accDrawingSets?.map((set) => {
                return {
                  value: set?.drawingSet?.attributes?.name?.split(".")[0],
                  label: set?.drawingSet?.attributes?.name?.split(".")[0],
                  data: set,
                };
              })}
              isSearchable={true}
              onChange={(e) => {
                drawingSetSelectHandler(e);
              }}
              value={{
                value:
                  selectedDrawingSet?.drawingSet?.attributes?.name?.split(
                    ".",
                  )[0],
                label:
                  selectedDrawingSet?.drawingSet?.attributes?.name?.split(
                    ".",
                  )[0],
                data: selectedDrawingSet,
              }}
              // isDisabled={!selectedProject}
            />
          </div>
        </div>
        <div className="row">
          <div
            className="col"
            style={{ textAlign: "center", margin: "5px" }}
            data-bs-toggle="tooltip"
          >
            <button
              type="button"
              className="btn mwh-btn-primary btn-sm"
              onClick={(e) => {
                setDrawingSetModal(true);
              }}
              style={{ marginRight: "4px", fontSize: "12px" }}
              disabled={!selectedDrawingSet}
            >
              View Drawing Set Information
            </button>
          </div>
        </div>
        {/* <div className="row">
          <div
            className="col"
            style={{ textAlign: "center" }}
            // title={!isValid ? invalidMessage : null}
            // data-bs-toggle="tooltip"
          >
            <button
              type="button"
              className="btn mwh-btn-primary btn-sm"
              onClick={(e) => {
                setSubmitModalOpen(true);
              }}
              style={{ margin: "4px", fontSize: "12px" }}
              disabled={!isValid}
            >
              Change Asset Status
            </button>
          </div>
          <div
            className="col"
            style={{ textAlign: "center" }}
            // title={!isValid ? invalidMessage : null}
            // data-bs-toggle="tooltip"
          >
            <button
              type="button"
              className="btn mwh-btn-primary btn-sm"
              onClick={createDrawingSet}
              style={{ margin: "4px", fontSize: "12px" }}
              disabled={!isDrawingSetValid}
            >
              {isSaving ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <span>Request Drawing Set</span>
              )}
            </button>
          </div>
        </div> */}
      </div>
      {/* MODALS */}
      {/* <Modal
        show={submitModalOpen}
        onHide={onCloseModal}
        dialogClassName="markup-modal bg-dark"
        center="true"
      >
        <Modal.Header className="bg-dark text-white">
          <Modal.Title>Model management form</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close"
              onClick={onCloseModal}
              aria-label="Close"
            />
          </div>
        </Modal.Header>
        <Modal.Body className="bg-dark text-white rounded">
          <div className="row">
            <div className="col">
              <Form.Label>What is the desired status?</Form.Label>

              <Select
                className="mb-2"
                menuPortalTarget={document.body}
                styles={modalSelectStyles}
                onChange={(e) => {
                  setSubmissionData({
                    ...submissionData,
                    proposedStatus: e,
                  });
                }}
                options={regionalStatuses?.map((status) => {
                  return {
                    label: `${status.code} - ${status.description}`,
                    value: `${status.code} - ${status.description}`,
                    data: status,
                  };
                })}
                value={submissionData?.proposedStatus}
              />
              <Form.Label className="mt-1">Who is the checker?</Form.Label>
              <Select
                className="mb-2"
                menuPortalTarget={document.body}
                styles={modalSelectStyles}
                onChange={(e) => {
                  setSubmissionData({
                    ...submissionData,
                    checker: e.value,
                  });
                }}
                options={allProjectUsers
                  .filter((o) => checkerRoles.includes(o.role))
                  .map((user) => {
                    return { label: user.email, value: user.email };
                  })}
                value={{
                  value: submissionData?.checker,
                  label: submissionData?.checker,
                }}
              />
            </div>
            <div className="col ">
              <Form.Label className="mt-1">Comments</Form.Label>
              <Form.Control
                rows={4}
                as="textarea"
                onChange={(e) => {
                  setSubmissionData({
                    ...submissionData,
                    comments: {
                      id: 1,
                      user: userDetails.email,
                      date: new Date().toISOString(),
                      comment: e.target.value,
                    },
                  });
                }}
                value={submissionData?.comments?.comment}
              />
            </div>
          </div>
          <Row>
            <Col>
              <ButtonGroup>
                <Button
                  variant="outline-success"
                  size="sm"
                  style={{ width: "150px" }}
                  onClick={requestAssetReview}
                  disabled={
                    !submissionData?.checker || !submissionData?.proposedStatus
                  }
                >
                  Request asset check
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
        </Modal.Body>
      </Modal> */}
      <Modal
        show={viewModalOpen}
        onHide={closeViewModal}
        dialogClassName="project-info-modal drawing-set-info-modal"
        center="true"
      >
        <Modal.Header className="project-info-modal__header">
          <Modal.Title>Selected document information</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close project-info-modal__close"
              onClick={closeViewModal}
              aria-label="Close"
            />
          </div>
        </Modal.Header>
        <Modal.Body className="project-info-modal__body drawing-set-info-modal__body">
          <>
            <div className="row project-info-modal__actions-row">
              <div
                className="col text-center project-info-modal__actions"
                data-bs-toggle="tooltip"
              >
                <span
                  data-bs-toggle="tooltip"
                  title={
                    !isAuthorised()
                      ? "You can only change the status of files that you are authorised to do so via your role on this project."
                      : ""
                  }
                >
                  <button
                    type="button"
                    className="btn mwh-btn-primary btn-sm"
                    onClick={(e) => {
                      setStatusModal(true);
                    }}
                    disabled={!isAuthorised()}
                  >
                    Change Status
                  </button>
                </span>
              </div>
            </div>
            <div className="project-info-modal__grid-wrap drawing-set-info-modal__grid-wrap">
              <div className="project-config-grid-table">
                <AgGridReact
                  theme={agGridTheme}
                  ref={gridRef}
                  rowData={selectedModels}
                  columnDefs={viewColumnDefs}
                  defaultColDef={defaultColDef}
                  paginationAutoPageSize={viewGridPageSizeMode === "auto"}
                  paginationPageSizeSelector={false}
                  onGridReady={gridReady}
                  onGridSizeChanged={(params) => {
                    fitViewGridColumns(params.api);
                    if (viewGridPageSizeMode === "auto") {
                      applyViewGridPageSizeMode(params.api);
                    }
                  }}
                  onFirstDataRendered={(params) => {
                    fitViewGridColumns(params.api);
                    applyViewGridPageSizeMode(params.api);
                  }}
                  onSelectionChanged={selectionChanged}
                  gridOptions={agGridOptionsSingle}
                />
                <div className="project-config-grid-rows-view">
                  <Form.Label className="mb-0 me-2">Page size</Form.Label>
                  <Form.Select
                    size="sm"
                    value={viewGridPageSizeMode}
                    onChange={(e) => {
                      setViewGridPageSizeMode(e.target.value);
                    }}
                    style={{ maxWidth: "180px" }}
                  >
                    <option value="auto">Auto</option>
                    <option value="25">25 per page</option>
                    <option value="50">50 per page</option>
                    <option value="100">100 per page</option>
                    <option value="all">All (scroll)</option>
                  </Form.Select>
                </div>
              </div>
            </div>
          </>
        </Modal.Body>
      </Modal>
      <Modal
        show={statusModal}
        onHide={hideStatusModal}
        dialogClassName="project-info-modal project-status-modal"
        center="true"
      >
        <Modal.Header className="project-info-modal__header">
          <Modal.Title>Status Update Request</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close project-info-modal__close"
              onClick={hideStatusModal}
              aria-label="Close"
            />
          </div>
        </Modal.Header>
        <Modal.Body className="project-info-modal__body project-status-modal__body">
          <div className="row project-status-modal__form">
            <div className="col">
              <Form.Label>
                What is the desired status?
                <MandatoryFieldIndicator />
              </Form.Label>

              <Select
                className="mb-2"
                menuPortalTarget={document.body}
                styles={modalSelectStyles}
                onChange={(e) => {
                  setSubmissionData({
                    ...submissionData,
                    proposedStatus: e,
                  });
                }}
                options={regionalStatuses?.map((status) => {
                  return {
                    label: `${status.code} - ${status.description}`,
                    value: `${status.code} - ${status.description}`,
                    data: status,
                  };
                })}
                value={submissionData?.proposedStatus}
              />
              <Form.Label className="mt-1">
                Who is the checker?
                <MandatoryFieldIndicator />
              </Form.Label>
              <Select
                className="mb-2"
                menuPortalTarget={document.body}
                styles={modalSelectStyles}
                onChange={(e) => {
                  setSubmissionData({
                    ...submissionData,
                    checker: e.value,
                  });
                }}
                options={allProjectUsers
                  .filter((o) => checkerRoles.includes(o.role))
                  .map((user) => {
                    return { label: user.email, value: user.email };
                  })}
                value={{
                  value: submissionData?.checker,
                  label: submissionData?.checker,
                }}
              />
            </div>
            <div className="col ">
              <Form.Label className="mt-1">Comments</Form.Label>
              <Form.Control
                className="project-status-modal__textarea"
                rows={4}
                as="textarea"
                onChange={(e) => {
                  setSubmissionData({
                    ...submissionData,
                    comments: {
                      id: 1,
                      user: userDetails.email,
                      date: new Date().toISOString(),
                      comment: e.target.value,
                    },
                  });
                }}
                value={submissionData?.comments?.comment}
              />
            </div>
          </div>
          <Row>
            <Col>
              <ButtonGroup className="project-status-modal__actions">
                <Button
                  variant="outline-danger"
                  size="sm"
                  className="project-status-modal__action-btn"
                  onClick={hideStatusModal}
                >
                  Cancel
                </Button>
              </ButtonGroup>
              <ButtonGroup className="project-status-modal__actions">
                <Button
                  variant="outline-success"
                  size="sm"
                  className="project-status-modal__action-btn"
                  onClick={requestAssetReview}
                  disabled={
                    !submissionData?.checker || !submissionData?.proposedStatus
                  }
                >
                  Request check
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <MandatoryExplanation />
        </Modal.Body>
      </Modal>
      <DrawingSetModal
        show={drawingSetModal}
        onHide={closeDrawingSetModal}
        selectedDrawingSet={selectedDrawingSet}
      />
    </>
  );
};

export default InformationManagement;
